<template>
    <button class="btn btn-default"
            :class="buttonClass"
            @click="goToSellWithAccount">
        <i class="fa-solid"
           :class="buttonIcon"></i>
        {{ l(buttonText) }}
    </button>
</template>

<script>
import AppPath from '@/lib/Navigation/AppPath';
import { container } from '@/container';

export default {
    props: {
        /**
         * @type {CustomerAccount}
         */
        account: {
            type: Object,
            required: true,
        },
        buttonText: {
            type: String,
            default: 'NEW',
        },
        buttonIcon: {
            type: String,
            default: 'fa-plus',
        },
        buttonClass: {
            type: String,
            default: null,
        },
        defaultItemTypeTab: {
            type: String,
            default: null,
        },
        useAccountReturnPath: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        async goToSellWithAccount() {
            const cartService = container.cartService;

            const cart = cartService.createEmptyCart();
            cart.customer.account = this.account;

            if (this.defaultItemTypeTab) {
                cart.sellState.defaultItemTypeTab = this.defaultItemTypeTab;
            }

            if (this.useAccountReturnPath) {
                const returnPath = new AppPath(this.account.getAccountDetailsPath());
                returnPath.params = { r: 1 };
                cart.sellState.cancelCartReturnPath = returnPath;
                cart.sellState.successReturnPath = returnPath;
            }

            const cartSet = await cartService.setNewCart(cart, true);
            if (cartSet) {
                container.navigationService.viewSell();
            }
        },
    },
};
</script>
